import React, { useState } from "react";
import { TableCell, TableRow, Typography, useTheme } from "@mui/material";
import ToggleIcon from "../../Components/ToggleIcon";
import { useSocketClient } from "../../contexts/SocketClientProvider";
import useDeleteData from "../../hooks/useDeleteData";
import ToggleIconLink from "../../Components/ToggleIconLink";
import { IAutomation } from "./types";
import { useTranslation } from "react-i18next";

interface IAutomationListItemProps {
  automation: IAutomation;
}

const AutomationListItem = (props: IAutomationListItemProps) => {
  const { automation } = props;
  const [isEnabled, setIsEnabled] = useState<boolean>(automation.is_enabled);
  const socketClient = useSocketClient();
  const { t } = useTranslation();

  const deleteHandler = useDeleteData(
    t("Automation AUTOMATION", { automation }),
    `/automations/${automation.id}`
  );
  const { palette } = useTheme();

  const toggleIsEnabled = () => {
    const newIsEnabled = !isEnabled;
    socketClient.update_attribute({
      type: "automation",
      id: automation.id,
      attribute: "is_enabled",
      value: newIsEnabled,
    });
    setIsEnabled(newIsEnabled);
  };

  return (
    <TableRow data-cy={`automation-${automation.id}`}>
      <TableCell>
        <Typography data-cy="automation-name">{automation.name}</Typography>
      </TableCell>
      <TableCell align="center">
        <ToggleIcon
          name={isEnabled ? "play-circle-outline" : "stop-circle-outline"}
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          onClick={toggleIsEnabled}
          color={palette.primary.main}
        />
      </TableCell>
      <TableCell align="center">
        <ToggleIcon
          name={"delete"}
          onClick={deleteHandler}
          color={palette.primary.main}
          data-cy="automation-delete"
        />
      </TableCell>
      <TableCell align="center">
        <ToggleIconLink
          to={`/automations/${automation.id}`}
          name={"pencil"}
          color={palette.primary.main}
          data-cy="automation-edit"
        />
      </TableCell>
    </TableRow>
  );
};

export default AutomationListItem;
